import {useGetCheckoutV2Query} from '@dms/api/sales';

/**
 * Whether the checkout's documents are issued in the seller's name (commission sale mode 2). Keep
 * this the single place that derives the mode, so payment forms cannot disagree about it.
 */
export function useIsSellerAsSupplier(checkoutId: string) {
  const {data: checkout, isLoading, isError} = useGetCheckoutV2Query({checkoutId});

  return {isSellerAsSupplier: checkout?.sellerAsSupplierEnabled ?? false, isLoading, isError};
}
